import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
	AfterContentChecked,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BehaviorSubject, forkJoin, of, throwError } from 'rxjs';
import {
	catchError,
	debounceTime,
	distinctUntilChanged,
	finalize,
	mergeMap,
	switchMap,
	take,
	takeWhile,
	tap,
} from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import {
	BasisVO,
	IssueVO,
	LookupData,
	StatuteVO,
	SystemicCaseCriteria,
	SystemicCaseVO,
	SystemicNotificationRecipientsVO,
} from 'src/app/services/gen';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { WsCasesResponseInterface } from 'src/app/services/search-data.service';
import { SharedCodeService } from 'src/app/services/shared-code.service';
import { User } from 'src/app/services/UserManagement';
import {
	CONFIRM_SAVE_SYSTEMIC_CASE,
	LookUpDataTypes,
	LookUpStatusCodeCharge,
	LookUpStatusCodeInquiry,
	ScrollStrategy,
} from 'src/app/shared/common-structures/app.constants';
import { CaseDetailV2 } from 'src/app/shared/common-structures/case-detail';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { StringUtils } from 'src/app/shared/utility/stringUtils';
import { Utils } from 'src/app/shared/utility/utils';
import { DashboardService } from '../../dashboard/dashboard.service';
import { SharedAllegationSelectionComponent } from '../shared-allegation-selection/shared-allegation-selection.component';
import { SharedEditSystemicSearchCasesComponent } from '../shared-edit-systemic-search-cases/shared-edit-systemic-search-cases.component';
import { SharedPartiesService } from '../shared-parties.service';
import { SystemicService } from './../../systemic/systemic.service';

@Component({
	selector: 'app-shared-edit-systemic-case',
	templateUrl: './shared-edit-systemic-case.component.html',
	styleUrls: ['./shared-edit-systemic-case.component.scss'],
})
export class SharedEditSystemicCaseComponent implements OnInit, OnDestroy, AfterContentChecked {
	@ViewChild('statutes', { static: false }) statutes: SharedAllegationSelectionComponent;
	@ViewChild('hiddenTextCalcWidth', { static: false }) textEl: ElementRef;
	@ViewChild(MatSort, { static: true }) recipientSort: MatSort;
    @Input() showWatchList = true;
	@Input() systemicData: any;
	@Input() readonly: boolean = false;
	@Input() isSystemCase: boolean = false;
	@Input() hasOGC: boolean = false;
	@Input() statutesComb: StatuteVO[] = [];
	@Input() enableSystemicInvestigation: any;
	@Output('onSave') onSave: EventEmitter<any> = new EventEmitter();
	@Output() optionChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	systemicForm: UntypedFormGroup;
	privateOffices: LookupData[] = [];
	statusCtrl: AbstractControl;
	originalForm: any;
	showSelection = true;
	typeArray: LookupData[];
	statusArray: LookupData[];
	basisComb: BasisVO[] = [];
	issueComb: IssueVO[] = [];
	selectedStatutes: StatuteVO[] = [];
	selectedBasises: BasisVO[] = [];
	selectedIssuses: IssueVO[] = [];
	initStatutes: StatuteVO[] = [];
	initBasises: BasisVO[] = [];
	initIssuses: IssueVO[] = [];
	initStatutesCompleted: boolean = false;
	initBasisesCompleted: boolean = false;
	initIssusesCompleted: boolean = false;

	additionalIssues: string[] = [];
	minWidth = 510;
	additionalIssuesInputWidth = this.minWidth;
	staffArrayLoading: boolean;
	filteredStaffArray: User[];
	notificationRecipients: User[] = [];
	filteredRecipients: User[];
	recipientsLoading: boolean;
	recipientsDisplayColumns = [
		'isCoOwner',
		'personName',
		'workPhone',
		'emailAddress',
		'officeCode',
		'officeName',
		'action',
	];
	enablePreview: boolean = false;
	enableSave: boolean = false;
	recipientsDataSource: MatTableDataSource<User>;
	private observer$ = new BehaviorSubject(true);
	readonly separatorKeysCodes = [ENTER, COMMA];
	readonly RecordsToQueryCodes = [
		{ description: 'Charges Only', value: 'C', sendValue: LookUpStatusCodeCharge },
		{ description: 'Inquiries Only', value: 'I', sendValue: LookUpStatusCodeInquiry },
		{
			description: 'Inquiries & Charges',
			value: 'BOTH',
			sendValue: [...LookUpStatusCodeInquiry, ...LookUpStatusCodeCharge],
		},
	];
	watchCaseInfoMessage: string =
		'A query that tracks cases where a Respondent’s employment practices may involve systemic discrimination.';
	invesigationInfoMessage: string =
		'A formal investigation into a Respondent’s alleged systemic employment discrimination.';

	// public systemicDetail: SystemicCaseDetailResponse;
	public getDescriptionByValue = Utils.getDescriptionByValue;
	isSystemicModule = false;
	constructor(
		private cmnServ: CommonService,
		private sharedCodeServ: SharedCodeService,
		private sharedPartiesServ: SharedPartiesService,
		private loader: LoadingService,
		private alert: AlertService,
		public dialog: MatDialog,
		private fb: UntypedFormBuilder,
		private _cdrRef: ChangeDetectorRef,
		private dashboardServ: DashboardService,
		private systemicServ: SystemicService,
		private router: Router
	) {
		this.isSystemicModule = this.router.url.includes('/systemic-investigation');
	}

	ngOnInit(): void {
		this.getSharedCodes();
		this.initializeForm();
		this.initializeRecipientTable();
		if (this.systemicData) {
			this.populateForm();
		}
		this.privateOffices = this.cmnServ._getPrivateOffices();
	}

	/**
	 * @description initialize the inquiry information form
	 */
	private initializeForm() {
		this.systemicForm = this.fb.group({
			caseName: new UntypedFormControl(
				{ value: this.isSystemCase ? this.systemicData.caseNumber : null, disabled: this.readonly },
				[Validators.required]
			),
			//	type: new FormControl({ value: null, disabled: this.readonly }, [Validators.required]),
			status: new UntypedFormControl({ value: this.isSystemCase ? 'IN' : 'WL', disabled: this.readonly }, [
				Validators.required,
			]),
			ownerId: new UntypedFormControl({ value: null, disabled: this.readonly }, [Validators.required]),
			description: new UntypedFormControl({ value: null, disabled: this.readonly }),
			isAutoSearchDisabled: new UntypedFormControl({ value: this.isSystemCase ? true : null, disabled: this.isSystemCase }),
			notificationRecipientsVOS: new UntypedFormControl({ value: null, disabled: this.readonly }),
			caseCriteria: new UntypedFormGroup({
				respondents: new UntypedFormControl({ value: null, disabled: this.readonly }),
				eeo1HQ: new UntypedFormControl({ value: null, disabled: this.readonly }),
				eeo1Unit: new UntypedFormControl({ value: null, disabled: this.readonly }),
				status: new UntypedFormControl({ value: null, disabled: this.readonly }),
				closureLookUpDays: new UntypedFormControl({ value: 0, disabled: this.readonly }),
			}),
			officeCode: new UntypedFormControl(null, []),
		});
		if (this.isSystemCase) {
			this.enablePreview = true;
		}
		this.statusCtrl = this.systemicForm.get('status');
		this.setInitialValue();
		this.statusCtrl.valueChanges.subscribe((res) => {
			this.optionChange.emit(this.statusCtrl.value != 'IN');
			if (this.statusCtrl.value != 'IN') {
				this.enablePreview = true;
			}
		});
		this.systemicForm
			.get('ownerId')
			.valueChanges.pipe(
				takeWhile(() => this.observer$.value),
				debounceTime(500),
				distinctUntilChanged(),
				tap(() => {
					this.staffArrayLoading = true;
					this.filteredStaffArray = [];
				}),
				switchMap((name) =>
					this.cmnServ.getAssigneeListByName(name).pipe(finalize(() => (this.staffArrayLoading = false)))
				)
			)
			.subscribe((res) => {
				this.filteredStaffArray = this.filteredStaffArray.concat(...(res || []));
			});

		this.systemicForm
			.get('notificationRecipientsVOS')
			.valueChanges.pipe(
				takeWhile(() => this.observer$.value),
				debounceTime(500),
				distinctUntilChanged(),
				tap(() => {
					this.recipientsLoading = true;
					this.filteredRecipients = [];
				}),
				switchMap((name) =>
					this.cmnServ.getAssigneeListByName(name).pipe(finalize(() => (this.recipientsLoading = false)))
				)
			)
			.subscribe((res) => {
				this.filteredRecipients = this.filteredRecipients.concat(...(res || []));
			});
	}

	private initializeRecipientTable() {
		this.recipientsDataSource = new MatTableDataSource();
		this.recipientsDataSource.sort = this.recipientSort;
	}

	ngAfterContentChecked(): void {
		//Called after every check of the component's or directive's content.
		//Add 'implements AfterContentChecked' to the class.
		this._cdrRef.detectChanges();
	}

	/**
	 * @description get sharedCodes for type list and office code list
	 */
	private getSharedCodes() {
		this.sharedCodeServ.getSharedCodes(LookUpDataTypes.SYSTEMIC_TYPE).subscribe(
			(res) => (this.typeArray = res),
			(error) => this.alert.error('An error occurred while getting allegation SBI.', error)
		);
		this.sharedCodeServ.getSharedCodes(LookUpDataTypes.SYSTEMIC_STATUS).subscribe(
			(res) => (this.statusArray = res.filter((x) => !this.hasOGC || x.code != 'IN')),
			(error) => this.alert.error('An error occurred while getting status list.', error)
		);
	}

	private getAssignableStaffArray(staffArray: User[]): User[] {
		if (staffArray && staffArray.length > 0) {
			return staffArray
				.filter((item) => {
					for (const key in item.roleAssignments) {
						if (
							item.roleAssignments[key].find(
								(item) => item.roleCode.includes('SUPERVISOR') || item.roleCode.includes('STAFF')
							)
						) {
							return true;
						}
					}
					return false;
				})
				.sort(Utils.sortStaffByName);
		} else {
			return [];
		}
	}

	/**
	 * @description populate the form with input systemic case
	 */
	private populateForm() {
		const systemicDetail = this.systemicData?.systemicDetail;
		if (systemicDetail) {
			this.systemicForm.get('caseName').setValue(systemicDetail.systemicCase?.caseName);
			//this.systemicForm.get('type').setValue(systemicDetail.systemicCase?.type?.code);
			this.systemicForm.get('status').setValue(systemicDetail.systemicCase?.status?.code);
			this.systemicForm.get('description').setValue(systemicDetail.systemicCase?.description);
			this.systemicForm.get('isAutoSearchDisabled').setValue(systemicDetail.systemicCase?.autoSearchDisabled);
			this.additionalIssues = !Utils.isEmptyCondition(systemicDetail.systemicCase?.additionalIssues)
				? systemicDetail.systemicCase.additionalIssues.split(',')
				: [];
			if (systemicDetail?.systemicCase?.caseCriteria?.respondents?.length) {
				this.systemicForm
					.get(['caseCriteria', 'respondents'])
					.setValue(systemicDetail.systemicCase.caseCriteria.respondents.join(', '));
			}
			if (systemicDetail?.systemicCase?.caseCriteria?.eeo1HQ) {
				this.systemicForm
					.get(['caseCriteria', 'eeo1HQ'])
					.setValue(systemicDetail.systemicCase.caseCriteria.eeo1HQ.join(', '));
			}
			if (systemicDetail?.systemicCase?.caseCriteria?.eeo1Unit) {
				this.systemicForm
					.get(['caseCriteria', 'eeo1Unit'])
					.setValue(systemicDetail.systemicCase.caseCriteria.eeo1Unit.join(', '));
			}
			if (systemicDetail?.systemicCase?.caseCriteria?.closureLookUpDays) {
				this.systemicForm
					.get(['caseCriteria', 'closureLookUpDays'])
					.setValue(systemicDetail.systemicCase.caseCriteria.closureLookUpDays);
			}
			if (systemicDetail?.systemicCase?.caseCriteria?.status) {
				let value: any = 'BOTH';
				let status = systemicDetail?.systemicCase?.caseCriteria?.status || [];
				if (!status.includes('INQUIRY_SUBMITTED') && status.includes('CHARGE_FILED')) {
					value = 'C';
				} else if (status?.includes('INQUIRY_SUBMITTED') && !status.includes('CHARGE_FILED')) {
					value = 'I';
				}

				this.systemicForm.get(['caseCriteria', 'status']).setValue(value);
			}
			if (systemicDetail?.systemicCase?.ownerId) {
				this.loadUser(systemicDetail.systemicCase);
			}
		}
		if (this.systemicData?.isCharge) {
			this.cmnServ
				.getUserById(this.systemicData?.ownerId)
				.subscribe((res) => this.systemicForm.get('ownerId')?.setValue(res));

			this.systemicForm
				.get(['caseCriteria', 'respondents'])
				.setValue(this.systemicData?.caseCriteria?.respondents?.join(', '));
			this.populateSBI(this.systemicData?.caseCriteria);
		} else {
			this.populateNotificationRecipients();
			this.populateSBI(this.systemicData?.systemicDetail?.systemicCase?.caseCriteria);
		}
		this.setInitialValue();
	}

	/*
  @description Fetch userdetails by Id and setting the office and owner to form
  **/
	loadUser(id, setOwner = true) {
		this.cmnServ.getUserById(id.ownerId).subscribe((res) => {
			if (setOwner) {
				this.systemicForm.get('ownerId')?.setValue(res);
        this.setInitialValue();
			}
		});
		this.systemicForm.get('officeCode').setValue(id?.office?.code);
	}
  private setInitialValue() {
    this.originalForm = this.systemicForm.value;
  }

	private populateNotificationRecipients() {
		this.systemicData?.systemicDetail?.notificationRecipients.forEach((item) => {
			this.cmnServ.getUserById(item.recipientId).subscribe((res: any) => {
				res.isCoOwner = item.isCoOwner;
				this.notificationRecipients.push(res);
				this.updateRecipientTable();
			});
		});
	}
	clone(obj = {}) {
		return JSON.parse(JSON.stringify(obj));
	}
	private populateSBI(caseCriteria: SystemicCaseCriteria) {
    if(!caseCriteria){
      return;
    }
		this.selectedStatutes = caseCriteria?.statute?.map((item) => {
			return { statuteId: -1, shortName: item };
		}) || [];
		this.initStatutes = this.clone(this.selectedStatutes);
		this.selectedBasises = caseCriteria?.basis?.map((item) => {
			return { basisId: -1, shortName: item };
		}) || [];
		this.initBasises = this.clone(this.selectedBasises);
		this.selectedIssuses = caseCriteria?.issue?.map((item) => {
			return { issueId: -1, shortName: item };
		}) || [];
		this.initIssuses = this.clone(this.selectedIssuses);
	}

	// Allegation logic
	/**
	 * @description get selected category from the child and filter all possible sub-categories
	 */
	categorySelected(eventData: any[], category: string) {
		let data = JSON.parse(JSON.stringify(eventData));
		let temp = [];
		if (category === 'statute') {
			data.forEach((statue) => {
				(statue.basis || []).forEach((basis: any) => {
					if (!basis.originalDesc) {
						basis.originalDesc = basis.description;
					}
					basis.description = `${basis.originalDesc} (${statue.shortName})`;
					basis.id = basis.code + '_' + statue.shortName;
					temp.push(basis);
				});
			});
			// data.forEach((item) => (temp = temp.concat(item.basis)));
			// temp = _.uniqBy(temp, 'code');
			this.selectedStatutes = data;
			this.basisComb = temp;
			if (this.initStatutesCompleted) {
				this.enablePreview = true;
			}
		}
		if (category === 'basis') {
			data.forEach((item) => (temp = temp.concat(item.issue)));
			temp = _.uniqBy(temp, 'code');
			this.selectedBasises = data;
			this.issueComb = temp;
			if (this.initBasisesCompleted) {
				this.enablePreview = true;
			}
		}
		if (category === 'issue') {
			this.selectedIssuses = data;
			if (this.initIssusesCompleted) {
				this.enablePreview = true;
			}
		}

    this.isChanged();
	}

  isChanged() {
    let tempSelectedStatues = this.selectedStatutes?.map(x => x.code);
    let tempInitStatues = this.initStatutes?.map(x => x.code);
    let tempInitBasises = this.initBasises?.map(x => x.code);
    let tempSelectedBasises = this.selectedBasises?.map(x => x.code);
    let tempInitIssuses = this.initIssuses?.map(x => x.code);
    let tempSelectedIssuses = this.selectedIssuses?.map(x => x.code);

    if (_.isEqual(this.originalForm, this.systemicForm.value) && _.isEqual(tempSelectedStatues, tempInitStatues) &&
      _.isEqual(tempInitBasises, tempSelectedBasises) &&
      _.isEqual(tempInitIssuses, tempSelectedIssuses)) {
      this.enableSave = false;
    } else {
      this.enableSave = true;
    }
  }

	private generatePayload(): SystemicCaseVO {
		const rs = _.cloneDeep(this.systemicForm.value);
		rs.ownerId = rs.ownerId.userDetailId;
		rs.status = Utils.getLookupDataByCode(rs.status, this.statusArray);
		rs.isAutoSearchDisabled = rs?.status === 'IN' ? false : rs.isAutoSearchDisabled;
		//	rs.type = Utils.getLookupDataByCode(rs.type, this.typeArray);
		rs.notificationRecipientsVOS = this.notificationRecipients.map((item: any) => {
			const recepient: SystemicNotificationRecipientsVO = {
				recipientId: item.userDetailId,
				isCoOwner: item.isCoOwner || false,
			};
			return recepient;
		});
		if (rs?.status !== 'IN') {
			if (rs.caseCriteria?.status) {
				let query = this.RecordsToQueryCodes.find((s) => s.value == rs.caseCriteria.status.toString());
				rs.caseCriteria.status = query.sendValue;
			}
      const statuteCodes = this.selectedStatutes.filter((value, index, self) => index === self.findIndex(t => t.shortName === value.shortName)).map(c => c.code);
      rs.caseCriteria.statute = statuteCodes;

      const basisCodes = this.selectedBasises.filter((value, index, self) => index === self.findIndex(t => t.shortName === value.shortName)).map(c => c.code);
      rs.caseCriteria.basis = basisCodes;

      const issueCodes = [...this.selectedIssuses].filter((value, index, self) => index === self.findIndex(t => t.shortName === value.shortName)).map(c => c.code);
      rs.caseCriteria.issue = issueCodes;
			rs.additionalIssues = this.additionalIssues.join(', ');
			this.splitParameter(rs.caseCriteria, 'respondents');
			this.splitParameter(rs.caseCriteria, 'eeo1HQ');
			this.splitParameter(rs.caseCriteria, 'eeo1Unit');
			for (const key in rs.caseCriteria) {
				rs.caseCriteria[key] = Utils.notNullCondition(rs.caseCriteria[key]) ? rs.caseCriteria[key] : [];
			}
		}
		return rs;
	}

	private splitParameter(obj, parameterName) {
		const target = obj[parameterName];
		if (target && target.trim().length > 0) {
			obj[parameterName] = target.split(',').map((i) => i.trim());
		}
	}

	/**
	 * @description clear everything added
	 */
	public clear() {
		this.systemicForm.reset();
		this.systemicForm.get('status').setValue('WL');
		this.statutes.clearSelection();
		this.selectedStatutes = [];
		this.selectedBasises = [];
		this.selectedIssuses = [];
		this.additionalIssues = [];
		this.showSelection = false;
		this.additionalIssuesInputWidth = this.minWidth;
		this.enableSave = false;
		this.enablePreview = false;
		setTimeout(() => {
			this.notificationRecipients = [];
			if (this.systemicData) {
				this.populateForm();
			}
			this.showSelection = true;
		}, 250);
	}

	public displayFn = (staff) => {
		// input is string
		if (typeof staff === 'string') {
			return staff;
		}
		// input is user object
		if (staff) {
			return this.concatName(staff.personName);
		}
		return null;
	};

	public displayEmpty = (user) => '';

	/**
	 * @description call string utils' concatName to return a full name.
	 * @param person any
	 */
	public concatName(person): string {
		return person
			? StringUtils.concatName(person.lastName, person.middleInitial, person.firstName).toLocaleUpperCase()
			: null;
	}

	public selectFromAutoComplete(event) {
		const owner = this.systemicForm.get('ownerId').value;
		const user = event.option.value;
		if (owner && user.userDetailId === owner.userDetailId) {
			this.alert.warn('Notification recipient must not be the same as case owner.');
		} else {
			this.notificationRecipients.push(user);
			this.updateRecipientTable();
			this.enableSave = true;
		}
		this.systemicForm.get('notificationRecipientsVOS').setValue(null);
	}
	removeRecepient(user: User) {
		const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: {
				header: 'Remove Recepient',
				question: 'Are you sure you want to remove the Recepient?',
				button: 'Yes',
				buttonColor: 'accent',
				secondButton: 'No',
			},
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'remove-recipient-confirmation-dialog',
		});

		confirmDialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				if (res) this._removeRecepient(user);
			});
	}

	public _removeRecepient(user: User) {
		this.enableSave = true;
		this.notificationRecipients = this.notificationRecipients.filter((item) => item.userDetailId !== user.userDetailId);
		this.updateRecipientTable();
	}

	public addAdditionalIssue(event) {
		const input = event.input;
		const value = event.value;
		if ((value || '').trim()) {
			this.additionalIssues.push(value.trim());
		}
		// Reset the input value
		if (input) {
			input.value = '';
		}
		this.resize();
	}

	public removeAdditionalIssue(index) {
		this.additionalIssues.splice(index, 1);
		this.resize();
	}

  private resize() {
    const maxWidth = 1400;
    const newWidth = Math.max(this.minWidth, this.textEl.nativeElement.offsetWidth);
    this.additionalIssuesInputWidth = Math.min(newWidth, maxWidth);
  }

	public disableSave(): boolean {
		if (!this.systemicForm) {
			return true;
		}
		return (
			this.systemicForm.invalid ||
			(this.statusCtrl?.value !== 'IN' && !this.selectedStatutes?.length) ||
			this.readonly ||
			!this.enablePreview
		);
	}

	/**
	 * @description confirm save systemic case
	 */
	public confirmSave() {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: CONFIRM_SAVE_SYSTEMIC_CASE,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'confirm-save-systemic-case-dialog',
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res) {
				this.save();
			}
		});
	}

	private showSearchResults(results: WsCasesResponseInterface[], payload: SystemicCaseVO) {
		const data = {
			newCharges: results[0] ? results[0]?.dataRecords : [],
			oldCharges: results[1] ? results[1]?.dataRecords : [],
		};
		const dialogRef = this.dialog.open(SharedEditSystemicSearchCasesComponent, {
			width: '1400px',
			data: data,
			disableClose: false,
			panelClass: 'app-dialog-container-full-height',
			scrollStrategy: ScrollStrategy,
			id: 'edit-systemic-search-cases-dialog',
		});
		dialogRef.afterClosed().subscribe((res: CaseDetailV2[]) => {
			if (res) {
				this.onSave.emit({ payload, data: res });
			}
		});
	}

	saveCase() {
		const payload = this.generatePayload();
		this.loader.show();
		this.dashboardServ
			.updateSystemicCaseInformation(this.systemicData?.systemicDetail?.systemicCase.systemicCaseId, payload)
			.subscribe(
				(res) => {
					this.systemicServ.onSave.next(true);
					this.loader.hide();
					this.alert.success('Systemic data has been updated successfully.');
				},
				(error) => {
					this.loader.hide();
					if (error?.status === 422) {
						this.alert.error(error?.error , error);
					} else {
						this.alert.error('Error occurred while updating systemic data.', error);
					}
				}
			);
	}

	/**
	 * @description save systemic case
	 */
	public save(auto = false) {
		const payload = this.generatePayload();
		this.loader.show();
		const requests = [
			this.sharedPartiesServ.getChargesByCriteria(payload.caseCriteria).pipe(
				mergeMap((res) => {
					const newCharges = res.map((i) => i.chargeNumber);
					if (!newCharges?.length) return of([]);
					return this.cmnServ.getCasesByCaseNumber(newCharges);
				}),
				catchError((_) => throwError(null))
			),
		];
		if (this.systemicData?.systemicDetail) {
			const caseRelated = this.systemicData?.systemicDetail?.chargesRelated.map((i) => i.caseNumber);
			if (!caseRelated?.length) return of([]);
			requests.push(this.cmnServ.getCasesByCaseNumber(caseRelated));
		}
		forkJoin(requests).subscribe(
			(res: WsCasesResponseInterface[]) => {
				this.loader.hide();
				if (auto) {
					const rows = res[0].dataRecords || [];
					payload.chargesToRelate = rows.map((i) => {
						return {
							chargeId: i.ciChargeInquiryId,
						};
					});
					this.onSave.emit(payload);
				} else {
					this.showSearchResults(res, payload);
				}
			},
			(error) => {
				this.loader.hide();
				if (error?.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('An error occurred while searching charges. Please contact help desk.', error);
				}
			}
		);
	}

	private updateRecipientTable() {
		this.recipientsDataSource.data = this.notificationRecipients;
		this.recipientsDataSource._updateChangeSubscription();
	}

	ngOnDestroy(): void {
		this.observer$.next(false);
	}

	/**
	 * @description - retrieve the correct human readable value based on an item value passed in
	 * @param value - user selected value
	 * @param obj - object that is being searched on
	 * @returns - human readable value that is found, or undefined
	 */
	public getDescriptionByItemValue(value, obj) {
		if (obj) return obj.find((item) => item.value === value)?.description;
	}
}
